import _ from 'lodash'
import {CF, CFMemberComparator, getPosFromCFMember} from 'module/CustomField/util/CustomField'
import {CFMember, CFModel, CFSetOptions, CFValue} from 'module/CustomField/type/CFType'
import {CustomFieldTO} from 'generated/JavaTO'
import {Booking, Persurl} from 'generated/JavaTOmodifications'
import {_ensureCFMemberMinAmount} from 'module/CustomField/util/initCFDefModel'
import {isNullCFMember} from 'module/CustomField/util/isNullCFMember'

function rejectCF(cf: CFMember[] | undefined, dstFields: string[], pos?: number): CFMember[] {
	if (typeof pos === 'number') {
		return _.reject(cf, m => getPosFromCFMember(m) === pos && dstFields.includes(m.dstField))
	} else {
		return _.reject(cf, m => dstFields.includes(m.dstField))
	}
}

export const CFimmutable = {
	setModelAttr<T extends CFModel | Booking | Persurl>(model: T, attr: Partial<T>) {
		if (!model) return model;
		else return {...model, ...attr};
	},
	setCFValue<T extends CFModel | Booking | Persurl>(model: T, cfDef: CustomFieldTO, value: CFMember | CFValue, options?: CFSetOptions) {
		const nextModel = _.cloneDeep(model)
		CF.setValueTo(cfDef, nextModel, value, options)
		return nextModel
	},
	deleteCFValue<T extends CFModel | Booking | Persurl>(model: T, persistedModel: T | null | undefined, cfDefs: CustomFieldTO[], pos?: number, clearNullValues?: boolean) {
		const dstFields = cfDefs.map(CF.getCFNamespaceField)
		model = _.cloneDeep(model)
		if (clearNullValues) {
			model.cf = _.reject(model.cf, m => isNullCFMember(m) && dstFields.includes(m.dstField))
		} else {
			model.cf = rejectCF(model.cf, dstFields, pos).sort(CFMemberComparator)
		}
		_ensureCFMemberMinAmount(cfDefs, model, persistedModel)
		return model
	},
	moveCFValue<T extends CFModel | Booking | Persurl>(model: T, persistedModel: T | null | undefined, cfDefs: CustomFieldTO[], pos: number, up: boolean) {
		if (!model.cf) return model
		const dstFields = cfDefs.map(CF.getCFNamespaceField)
		const positions = model.cf.flatMap(m =>
			!dstFields.includes(m.dstField) ? [] : [getPosFromCFMember(m)],
		)
		const uPos = [...new Set(positions)].sort()
		const iPos = uPos.indexOf(pos)
		const iPosOther = (up ? -1 : +1) + iPos
		const posOther = uPos[iPosOther]
		// is first or last -> abort
		if (posOther === undefined) return model
		//check for holes or switch position with other
		const possibleHole = (up ? -1 : +1) + posOther
		let posNew = possibleHole < 0 || uPos.indexOf(possibleHole) > -1 ? posOther : possibleHole
		model = {
			...model,
			cf: model.cf.map(m => {
				if (!dstFields.includes(m.dstField)) return m
				const memPos = getPosFromCFMember(m)
				if (memPos === pos) {
					m = {...m, moveToPos: posNew}
				} else if (memPos === posNew) {
					m = {...m, moveToPos: pos}
				}
				if (m.moveToPos === m.pos) m = {...m, moveToPos: undefined}
				return m
			}).sort(CFMemberComparator),
		}
		return model
	},
	refreshModelCFAttachment<T extends CFModel | Booking | Persurl>(model: T, cfMember: CFMember): T {
		// call on model and persistedModel!
		const {dstField, pos} = cfMember;
		return {
			...model,
			cf: rejectCF(model.cf, [dstField], pos)
				.concat(cfMember)
				.sort(CFMemberComparator),
		} as T
	},
}